import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { updateMenuSection } from 'src/api/updateMenuSection/updateMenuSection';
import { ISection } from 'src/types/menu.types';
import { QueryKeys } from '../QueryKeys';

export interface IUpdateSectionAvailabilityPayload {
  instanceIds?: string[] | null;
  venueIds?: string[] | null;
}

export const useUpdateSectionAvailability = (menuId: string, section: ISection, onMutationSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    (payload: IUpdateSectionAvailabilityPayload) =>
      updateMenuSection(menuId, section.sectionId, {
        name: section.name,
        description: section.description,
        items: section.items.map((item) => item.itemId),
        ...payload,
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [QueryKeys.menu, menuId] });
        showSnackbar({
          message: 'You have successfully updated the menu section availability',
          status: SnackbarStatus.SUCCESS,
        });
        onMutationSuccess?.();
      },
    },
  );
};
